import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import './utils/axiosConfig';
import AppWrapper from './App';

Sentry.init({
    dsn: "https://0b91ff374297618c8ff315d4751960bb@o4510132009107456.ingest.us.sentry.io/4510201193496576",
    environment: "production",
    tracesSampleRate: 0.1,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
            <AppWrapper />
        </Sentry.ErrorBoundary>
    </React.StrictMode>
);
